<nb-layout>
  <nb-sidebar>Sidebar Content</nb-sidebar>
</nb-layout>
